import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'itpx-font-size-dropdown',
    templateUrl: './font-size-dropdown.component.html',
    styleUrls: ['./font-size-dropdown.component.scss']
})
export class FontSizeDropdownComponent implements OnInit {

    @Output()
    onSizeSelect = new EventEmitter<number>();

    sizes = [8, 9, 10, 11, 12, 14, 18, 22, 24, 30];

    constructor() {
    }

    ngOnInit() {
    }

    onSelect(size: number) {
        this.onSizeSelect.emit(size);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/silk/toolbars/standard-toolbar/font-size-dropdown/font-size-dropdown.component.ts